import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import helperTextError from '@/components/mui/Form/TextField/helperTextError';
import { limitedMenuProps } from '@/components/mui/Form/Autocomplete/visibleOptions';
import type { PayingAccountField } from '@/domain/paySettings/schemas';

type Props = {
  field: PayingAccountField;
  disabled: boolean;
};

const SelectField: React.FC<Props> = ({ field, disabled }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={field.name}
      control={control}
      render={({ field: f, fieldState }) => (
        <TextField
          select
          fullWidth
          required
          size="small"
          slotProps={{ select: { MenuProps: limitedMenuProps } }}
          label={field.label}
          disabled={disabled}
          value={typeof f.value === 'string' ? f.value : ''}
          onChange={f.onChange}
          onBlur={f.onBlur}
          inputRef={f.ref}
          error={!!fieldState.error}
          helperText={helperTextError(fieldState.error?.message)}
        >
          {(field.options ?? []).map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  );
};

export default SelectField;
